import React, { CSSProperties } from 'react'
import { Box, Icon, Link as MaterialLink, useTheme } from '@mui/material'
import { getClassName, parseClassNames } from '../../utils'
import { cx } from '@emotion/css'
import { CssStyles } from '../../types'

export interface ILink {
  text?: string
  isExternal?: boolean
  /** *Deprecated* Raw CSS styles
   * @deprecated
   */
  styles?: CssStyles<'root' | 'link' | 'icon'>
  onClick?: () => unknown

  style?: CSSProperties | string
  linkStyle?: CSSProperties | string
  iconStyle?: CSSProperties | string
}

export const Link = React.forwardRef<HTMLSpanElement, ILink>(
  ({ text, isExternal, styles, onClick, style, linkStyle, iconStyle }, ref) => {
    const theme = useTheme()

    const classNames = styles && parseClassNames(styles)

    return (
      <Box
        display="flex"
        component="span"
        ref={ref}
        className={cx(classNames?.root, getClassName(style))}
      >
        <MaterialLink
          component="button"
          variant="body1"
          underline="none"
          onClick={onClick}
          className={cx(classNames?.link, getClassName(linkStyle))}
          sx={{
            lineHeight: 1,
            color: theme.palette.text.primary,
            borderBottom: `solid 1px ${theme.palette.primary.main}`,
            paddingLeft: theme.spacing(0.3),
            paddingRight: theme.spacing(0.3),
            paddingTop: theme.spacing(0.3),
            paddingBottom: theme.spacing(0.2),
            '&:hover': {
              backgroundColor: theme.palette.primary[50],
            },
            '&:focus:active': {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.white.main,
            },
          }}
        >
          {text}
        </MaterialLink>
        {isExternal && (
          <Icon
            className={cx(classNames?.icon, getClassName(iconStyle))}
            sx={{
              '&.material-icons': { fontSize: '1rem' },
              marginLeft: theme.spacing(0.1),
              color: theme.palette.grey[700],
            }}
          >
            open_in_new
          </Icon>
        )}
      </Box>
    )
  }
)

if (process.env.NODE_ENV !== 'production') {
  Link.displayName = 'Link'
}
